module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "title": "A Split Worlds Omnibus (BOOKS 1–3)"
    }
  }, [_vm._v("A Split Worlds Omnibus"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOOKS 1–3")])]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/1_BTT_TITLEPAGE"
    }
  }, [_c('i', [_vm._v("Between Two Thorns")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/Text/2_AON_TITLEPAGE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Any Other Name")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/3_AIF_TITLEPAGE",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("All is Fair")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a1fd87","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FM1_TitlePage.vue
// module id = 60
// module chunks = 0